type Config = {
  ossUrl?: string
  ossUrl1?: string
  cdnUrl?: string
  params?: string
}

const defaultConfig: Config = {
  ossUrl: 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com',
  ossUrl1: 'https://cdn.zhiyitech.cn',
  cdnUrl: 'https://img-cdn.zhiyitech.cn',
  params: '', // eq: 'resize,w_1000/quality,Q_100'
}

export const picProcess = (url: string, config?: Config): string => {
  const _config = { ...defaultConfig, ...config }
  const { ossUrl, ossUrl1, cdnUrl, params } = _config
  if ((ossUrl || ossUrl1) && cdnUrl && url && (url.includes(ossUrl) || url.includes(ossUrl1))) {
    const _url = url.replace(ossUrl || ossUrl1, cdnUrl)
    return params ? `${_url}?image_process=${params}` : _url
  }
  return url
}
